import { AppPositionsElement, PositionsElement } from '@models/positions';
import axiosInstance from '../../utils/http-client';

export const getAllPositions = (slug: string, lang: string): Promise<PositionsElement> => {
  return axiosInstance.get(`/api/v1/client/${slug}/positions?lang=${lang}`, {});
};

export const getPositionsPerCategory = (slug: string, category: string, lang: string): Promise<PositionsElement> => {
  return axiosInstance.get(`/api/v1/client/${slug}/positions?category=${category}&lang=${lang}`, {});
};

export const getAllAppPositions = (
  PageNumber?: number,
  PageSize?: number,
  keyword?: string,
  status?: string,
  lang?: string,
): Promise<AppPositionsElement> => {
  const parameters: { params: any; paramsSerializer: any } = {
    params: {},
    paramsSerializer: { indexes: null },
  };

  if (keyword) {
    parameters.params.keyword = keyword;
  }
  if (lang) parameters.params.lang = lang;
  if (status) {
    parameters.params.status = status;
  }
  // const url = status
  //   ? `/api/v1/app/positions?PageNumber=${PageNumber}&PageSize=${PageSize}&status=${status}${
  //       lang !== undefined ? `&lang=${lang}` : ''
  //     }`
  //   : `/api/v1/app/positions?PageNumber=${PageNumber}&PageSize=${PageSize}${lang !== undefined ? `&lang=${lang}` : ''}`;
  // return axiosInstance.get(url, {});
  return axiosInstance.get(`/api/v1/app/positions?PageNumber=${PageNumber}&PageSize=${PageSize}`, parameters);
};
